require('mq-genie');
var $ = jQuery = require('jquery');
require('fancybox')($);
require('script-loader!jquery.easing');
require('script-loader!jquery.cycle2');
require('script-loader!jquery.cycle2.swipe');
require('script-loader!readmore-js');
require('script-loader!./thirdparty/owl.carousel.min.js');
require('script-loader!./thirdparty/jquery.mmenu.all.js');
require('script-loader!jquery.nicescroll');

jQuery.noConflict();

if (document.images) {
    p = new Image();
    p.src = "/themes/civilcon/images/loading-ow.gif";
    p = new Image();
    p.src = "/themes/civilcon/images/loading-wo.gif";
    p = new Image();
    p.src = "/themes/civilcon/images/marker.png";
}

(function($) {
    var map;
    var menuButton;
    var mobilemenu = true;
    var mobile = false;
    var mmgenerated = false;
    var sidebar;
    var dynamicrequest = null;
    var mmAPI;
    var mmenu = false;
    var ajaxload = null;
    var ajaxholder = null;
    var mobileortablet = false;
    var body;
    var winwidth = $(window).width();
    var winwidthkey;
    var winwidthkeyloaded = false;

    var menuSetup = function() {
        mmenu = $("#menu");

        $('.js-menu-btn').attr('href', '#menu');

        mmenu.find('.current').addClass('Selected');
        mmenu.mmenu({
            slidingSubmenus: false,
            extensions: [
                "theme-dark",
                "position-right"
            ],
            navbar: false
        });

        mmAPI = mmenu.data("mmenu");
    }

    var popup = function(url, width, height) {
        popupWindow = window.open(url, '_blank', 'location=no,menubar=no,width=' + width + ',height=' + height + ',toolbar=no,scrollbars=yes,resizable=no');
        popupWindow.focus();
    };

    var emailsiteProtect = function() {
        $('span.emailsite').each(function() {
            var word = $(this).attr('data-word');
            var linkclass = $(this).attr('data-linkclass');
            var e_a = "to";
            var e_b = $(this).attr('data-eb');
            var e_c = "@";
            var e_d = $(this).attr('data-ed');
            var e_e = "mail";
            var e_f = $(this).attr('data-ef');

            if (word == '' || word == (e_d + e_f + e_c + e_b)) {
                word = e_d + e_f + e_c + '<span class="zerospace"> </span>' + e_b.replace(".", '.<span class="zerospace"> </span>');
            }

            $(this).html('<a href="' + e_e + e_a + ':' + e_d + e_f + e_c + e_b + '"' + (linkclass == '' ? '' : (' class="' + linkclass + '"')) + '>' + word + '<' + '/' + 'a>');

        });
    };

    var setBoxHeights = function(className) {
        var pheight = 0;
        var checkheight;
        var setheight;
        $(className).css('min-height', pheight);

        $(className).each(function() {
            checkheight = $(this).outerHeight();
            if (checkheight > pheight) {
                setheight = $(this).height();
                pheight = checkheight;
            }
        });

        $(className).css('min-height', setheight + 1);
    };

    var googleMapsInitialize = function() {
        var mapobj = $('#map');

        if (mapobj.length != 0) {
            new googleMapsCreate(mapobj);
        } else {
            $('ul.map a.map').click(function() {
                var maplink = $(this);
                var attributes = $(this).prop("attributes");

                mapobj = $("<div>").addClass('map').attr('id', 'map' + Date.now()).fadeIn(250, function() {
                    $.each(attributes, function() {
                        mapobj.attr(this.name, this.value);
                    });

                    maplink.parent().parent().after(mapobj);
                    maplink.remove();

                    new scrollToDiv(mapobj, 0);

                    new googleMapsCreate(mapobj);
                });
            });
        }
    };

    var googleMapsCreate = function(mapobj) {
        var mapid = mapobj.attr('id');
        var maplat = mapobj.attr('data-lat');
        var maplng = mapobj.attr('data-lng');
        var mapicon = mapobj.attr('data-icon');

        var image = '/themes/civilcon/images/marker.png';

        var icon = {
            url: image,
            size: new google.maps.Size(51, 62),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(25, 55)
        }

        function initialize() {
            var mapOptions = {
                zoom: 15,
                center: new google.maps.LatLng(maplat, maplng)
            };

            map = new google.maps.Map(document.getElementById(mapid), mapOptions);

            var iconLatLng = new google.maps.LatLng(maplat, maplng);
            var iconMarker = new google.maps.Marker({
                position: iconLatLng,
                map: map,
                icon: icon,
            });

        }

        setTimeout(function() {
            initialize()
        }, 250);
    };

    var mapLoaded = false;
    var overlay;
    var mapSetup = function() {
        var mapid = 'mapinline';


        if (!mapLoaded) {
            setTimeout(function() {
                new contactSetup(mapid);
            }, 200);

            $(window).resize(function() {
                google.maps.event.trigger(map, 'resize');
            });

            mapLoaded = true;
        } else {


            setTimeout(function() {
                google.maps.event.trigger(map, 'resize');
            }, 200);
        }
    };

    var contactSetup = function(mapid) {
        var maplat = -45.010576;
        var maplng = 168.75352;
        var markers = [];
        var coords = [];
        var markersDisplay = [];

        var image = '/themes/civilcon/images/marker.png';

        var icon = {
            url: image,
            size: new google.maps.Size(51, 62),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(25, 55)
        }

        $('a.mapmarker').each(function() {
            markers.push({
                latitude: $(this).data('lat'),
                longitude: $(this).data('lng'),
                id: $(this).data('id'),
                title: $(this).attr('title'),
                content: $(this).text(),
                image: $(this).data('image'),
                phone: $(this).data('phone'),
                story: $(this).data('story'),
                bind: 1
            });

            $(this).click(function(event) {
                event.preventDefault();

                google.maps.event.trigger(markersDisplay[$(this).data('id')], 'click');

                new scrollToDiv($('#' + mapid), 0);
            });
        });

        function initialize() {
            var mapOptions = {
                zoom: 16,
                center: new google.maps.LatLng(maplat, maplng)
            };

            var infoWindow = new google.maps.InfoWindow({
                content: ''
            });

            map = new google.maps.Map(document.getElementById(mapid), mapOptions);

            overlay = new google.maps.OverlayView();
            overlay.draw = function() {};
            overlay.setMap(map);

            google.maps.event.addListener(map, 'click', function() {
                infoWindow.close();
            });

            for (var i = 0; i < markers.length; i++) {
                newlatlng = new google.maps.LatLng(markers[i].latitude, markers[i].longitude);

                if (markers[i].bind) {
                    coords.push(newlatlng);
                }

                var marker = new google.maps.Marker({
                    position: newlatlng,
                    title: markers[i].title,
                    map: map,
                    icon: icon,
                    id: markers[i].id
                });

                google.maps.event.addListener(marker, 'click', (function(marker, i) {
                    return function() {
                        var infoBox = new InfoBox({
                            latlng: marker.getPosition(),
                            map: map,
                            image: markers[i].image,
                            content: '<h2>' + markers[i].title + '</h2><h3 class="icon-markerthick">Details</h3><p>' + markers[i].phone + '<br /><a href="http://maps.apple.com/?daddr=' + markers[i].latitude + ',' + markers[i].longitude + '" target="_blank">' + markers[i].content + '</a></p><h3 class="icon-scroll">Story</h3>' + markers[i].story
                        });
                        //infoWindow.setPosition(this.position);
                        //infoWindow.setContent('<p><strong>'+this.title+'</strong></p><p>'+this.content+'</p>');
                        //infoWindow.open(map, marker);
                    }
                })(marker, i));

                markersDisplay[markers[i].id] = marker;
            }

            var bounds = new google.maps.LatLngBounds();
            for (var i = 0, LtLgLen = coords.length; i < LtLgLen; i++) {
                bounds.extend(coords[i]);
            }

            map.fitBounds(bounds);

            /* An InfoBox is like an info window, but it displays
             * under the marker, opens quicker, and has flexible styling.
             * @param {GLatLng} latlng Point to place bar at
             * @param {Map} map The map on which to display this InfoBox.
             * @param {Object} opts Passes configuration options - content,
             *   offsetVertical, offsetHorizontal, className, height, width
             */
            function InfoBox(opts) {
                google.maps.OverlayView.call(this);
                this.latlng_ = opts.latlng;
                this.map_ = opts.map;
                this.content_ = opts.content;
                this.image_ = opts.image;
                this.offsetVertical_ = -408;
                this.offsetHorizontal_ = -160;
                this.height_ = 388;
                this.width_ = 320;

                var me = this;
                this.boundsChangedListener_ =
                    google.maps.event.addListener(this.map_, "bounds_changed", function() {
                        return me.panMap.apply(me);
                    });

                // Once the properties of this OverlayView are initialized, set its map so
                // that we can display it.  This will trigger calls to panes_changed and
                // draw.
                this.setMap(this.map_);
            }

            /* InfoBox extends GOverlay class from the Google Maps API
             */
            InfoBox.prototype = new google.maps.OverlayView();

            /* Creates the DIV representing this InfoBox
             */
            InfoBox.prototype.remove = function() {
                if (this.div_) {
                    this.div_.parentNode.removeChild(this.div_);
                    this.div_ = null;
                }
            };

            /* Redraw the Bar based on the current projection and zoom level
             */
            InfoBox.prototype.draw = function() {
                // Creates the element if it doesn't exist already.
                this.createElement();
                if (!this.div_) return;

                // Calculate the DIV coordinates of two opposite corners of our bounds to
                // get the size and position of our Bar
                var pixPosition = this.getProjection().fromLatLngToDivPixel(this.latlng_);
                if (!pixPosition) return;

                // Now position our DIV based on the DIV coordinates of our bounds

                this.div_.style.left = (pixPosition.x + this.offsetHorizontal_) + "px";
                this.div_.style.top = (pixPosition.y + this.offsetVertical_) + "px";
                this.div_.style.display = 'block';
            };

            /* Creates the DIV representing this InfoBox in the floatPane.  If the panes
             * object, retrieved by calling getPanes, is null, remove the element from the
             * DOM.  If the div exists, but its parent is not the floatPane, move the div
             * to the new pane.
             * Called from within draw.  Alternatively, this can be called specifically on
             * a panes_changed event.
             */
            InfoBox.prototype.createElement = function() {
                var panes = this.getPanes();
                var div = this.div_;
                if (!div) {
                    // This does not handle changing panes.  You can set the map to be null and
                    // then reset the map to move the div.
                    div = this.div_ = document.createElement("div");
                    div.className = 'infobox';
                    //div.style.width = this.width_ + "px";
                    //div.style.height = this.height_ + "px";

                    var image = document.createElement("img");
                    image.src = this.image_;
                    image.className = 'image';

                    var contentDiv = document.createElement("div");
                    contentDiv.className = 'content';
                    if (this.image_ == '') {
                        contentDiv.className = 'content contentnoimage';
                    }
                    contentDiv.innerHTML = this.content_; //"<b>Hello World!</b>";

                    var topDiv = document.createElement("div");
                    topDiv.className = 'top';

                    var closeImg = document.createElement("img");
                    closeImg.src = "/themes/civilcon/images/closebigger.gif";
                    topDiv.appendChild(closeImg);

                    function removeInfoBox(ib) {
                        return function() {
                            ib.setMap(null);
                        };
                    }

                    google.maps.event.addDomListener(closeImg, 'click', removeInfoBox(this));

                    div.appendChild(topDiv);
                    div.appendChild(image);
                    div.appendChild(contentDiv);
                    //div.style.display = 'none';
                    panes.floatPane.appendChild(div);
                    this.panMap();
                } else if (div.parentNode != panes.floatPane) {
                    // The panes have changed.  Move the div.
                    div.parentNode.removeChild(div);
                    panes.floatPane.appendChild(div);
                } else {
                    // The panes have not changed, so no need to create or move the div.
                }
            }

            /* Pan the map to fit the InfoBox.
             */
            InfoBox.prototype.panMap = function() {
                // if we go beyond map, pan map
                var map = this.map_;
                var bounds = map.getBounds();
                if (!bounds) return;

                // The position of the infowindow
                var position = this.latlng_;

                // The dimension of the infowindow
                var iwWidth = this.width_;
                var iwHeight = this.height_;

                // The offset position of the infowindow
                var iwOffsetX = this.offsetHorizontal_;
                var iwOffsetY = this.offsetVertical_;

                // Padding on the infowindow
                var padX = 20;
                var padY = 20;

                // The degrees per pixel
                var mapDiv = map.getDiv();
                var mapWidth = mapDiv.offsetWidth;
                var mapHeight = mapDiv.offsetHeight;
                var boundsSpan = bounds.toSpan();
                var longSpan = boundsSpan.lng();
                var latSpan = boundsSpan.lat();
                var degPixelX = longSpan / mapWidth;
                var degPixelY = latSpan / mapHeight;

                // The bounds of the map
                var mapWestLng = bounds.getSouthWest().lng();
                var mapEastLng = bounds.getNorthEast().lng();
                var mapNorthLat = bounds.getNorthEast().lat();
                var mapSouthLat = bounds.getSouthWest().lat();

                // The bounds of the infowindow
                var iwWestLng = position.lng() + (iwOffsetX - padX) * degPixelX;
                var iwEastLng = position.lng() + (iwOffsetX + iwWidth + padX) * degPixelX;
                var iwNorthLat = position.lat() - (iwOffsetY - padY) * degPixelY;
                var iwSouthLat = position.lat() - (iwOffsetY + iwHeight + padY) * degPixelY;

                // calculate center shift
                var shiftLng =
                    (iwWestLng < mapWestLng ? mapWestLng - iwWestLng : 0) +
                    (iwEastLng > mapEastLng ? mapEastLng - iwEastLng : 0);
                var shiftLat =
                    (iwNorthLat > mapNorthLat ? mapNorthLat - iwNorthLat : 0) +
                    (iwSouthLat < mapSouthLat ? mapSouthLat - iwSouthLat : 0);

                // The center of the map
                var center = map.getCenter();

                // The new map center
                var centerX = center.lng() - shiftLng;
                var centerY = center.lat() - shiftLat;

                // center the map to the new shifted center
                map.setCenter(new google.maps.LatLng(centerY, centerX));

                // Remove the listener after panning is complete.
                google.maps.event.removeListener(this.boundsChangedListener_);
                this.boundsChangedListener_ = null;
            };
        }

        google.maps.event.addDomListener(window, 'load', initialize);
    };

    var gallerySetup = function() {
        if ($('.js-galleryviewmore').length) {
            $('.js-galleryviewmore').click(function() {
                $(this).remove();
                var images = $('.js-gallery li:hidden');
                images.css({
                    'display': 'block',
                    'opacity': 0
                })
                images.each(function(tag) {
                    $(this).delay(tag * 200).fadeTo(200, 1);
                });
            })
        }
    }

    var videoslideshowSetup = function(vid, vloop, vdots) {
        if (vloop) {
            // Fix issue when only one image
            vloop = ($('#' + vid + ' div.item').length > 1 ? true : false);
        }

        $("#" + vid).owlCarousel({
            items: 1,
            video: true,
            nav: vloop,
            navText: ['m', 'l'],
            loop: vloop,
            callbacks: true,
            dots: false,
            dotsContainer: 'div.videoslideshowpager',
            responsive: {
                550: {
                    dots: vdots
                }
            },
            autoplay: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true,
            lazyLoad: true,
            onInitialized: function() {
                new videoslideshowMarginTop(vid);
            },
            onResized: function() {
                new videoslideshowMarginTop(vid);
            }
        });

        // Custom Navigation Events
        if (vloop) {
            $('a.controlnext').click(function() {
                $("#" + vid).trigger('next.owl.carousel');
            });
            $('a.controlprev').click(function() {
                $("#" + vid).trigger('prev.owl.carousel');
            });
        }
    };

    var videoslideshowMarginTop = function(vid) {
        vheight = Math.ceil($('#' + vid + ' div.owl-stage-outer').width() * 0.56266666666667);

        if (vheight > 950) {
            vheight = 950;
            //margintop=Math.floor((vheight-650)/2);

            //$('#'+vid+' div.owl-item div.item').css('margin-top', '-'+margintop+'px');
            //$('#'+vid+' div.owl-item div.item div.imgtext').css('margin-bottom', ''+margintop+'px');

            //vheight = Math.floor(vheight-(margintop));
        } else {
            //$('#'+vid+' div.owl-item div.item, #'+vid+' div.owl-item div.item div.imgtext').css('margin', 0);
        }

        $('#' + vid + ' div.owl-item div.item, #' + vid + ' div.owl-video-tn').css('min-height', vheight);
    };

    var carouselSetup = function(id, initialnum, sizes) {
        var owl = $("#" + id + "carousel");

        var currentSlide = $("#" + id + "carousel div." + id + "inner.currentjob").parent().index();

        console.log(currentSlide);

        owl.owlCarousel({
            loop: true,
            callbacks: true,
            nav: true,
            navText: ['m', 'l'],
            items: initialnum,
            responsive: sizes,
            startPosition: currentSlide,
            onInitialized: function() {
                if (id == "otherbox") {
                    //setTimeout(function(){new setBoxHeights('div.'+id);}, 200);
                }
            },
            onResized: function() {
                if (id == "otherbox") {
                    //new setBoxHeights('div.'+id);
                }
            }
        });
    };

    var historyBack = function() {
        window.history.back();
    };

    var scrollToDiv = function(element, offsetadjust) {
        if (element == 0) {
            var totalScroll = offset;
        } else {
            var offset = element.offset();
            var totalScroll = (offset.top - offsetadjust);
        }

        var animtime = (totalScroll * .5);
        animtime = (animtime < 500 ? 500 : animtime);

        $('body,html').animate({
            scrollTop: totalScroll,
            easing: 'easeOutCubic'
        }, animtime);
    };

    var breakpointKey = function(breakpoints, width) {

        $.each(breakpoints, function(bkey, bwidth) {
            if (width > bwidth) {
                winwidthkey = bkey;
            }
        });
    }

    var shareSetup = function(selector) {
        $(selector + 'a.js-share').click(function(event) {
            event.preventDefault();
            popupWindow = window.open($(this).attr('href'), '_blank', 'location=no,menubar=no,width=600,height=480,toolbar=no,scrollbars=yes,resizable=no');
            popupWindow.focus();
        });
    };

    $(document).ready(function() {
        body = $('body');
        mobileortablet = body.data('mobileortablet');

        if (!mobileortablet) {
            $("html").niceScroll({
                cursorborder: "",
                cursorcolor: "#211b14",
                zindex: 201,
                autohidemode: false,
                horizrailenabled: false,
                cursorwidth: 6
            });
            $(".quoteinner").niceScroll({
                cursorborder: "",
                cursorcolor: "#ffb266",
                zindex: 201,
                autohidemode: false,
                horizrailenabled: false,
                cursorwidth: 6
            });
        }

        if ($('#videoslideshow div.item').length > 0) {
            new videoslideshowSetup('videoslideshow', true, true);
        }

        if ($('#videoonlyslideshow div.item').length > 0) {
            new videoslideshowSetup('videoonlyslideshow', false, false);
        }

        new gallerySetup();

        if ($('.js-readmore').length) {
            $('.js-readmore').readmore({
                speed: 400,
                collapsedHeight: 110,
                moreLink: '<a href="#" class="readmore">Read more</a>',
                lessLink: '<a href="#" class="readmore">Close</a>'
            });
        }

        if ($('#ajaxcarousel').length > 0) {
            var baseurl = window.location.href;

            responsive = {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                800: {
                    items: 5
                }
            };
            new carouselSetup('ajax', 5, responsive);

            ajaxload = $('#ajaxload');
            $('#ajaxcarousel ul.readmorepage a').click(function(event) {
                event.preventDefault();

                var ajaxitem = $(this);

                if (ajaxitem.closest('div.ajax').hasClass('current')) {
                    ajaxitem.text('Read More').closest('div.ajax').removeClass('current');
                    ajaxload.html('').removeAttr('style');

                    window.history.pushState(baseurl, null, baseurl);
                } else {
                    $('#ajaxcarousel div.ajax').removeClass('current');

                    ajaxload.addClass('loading').html('');

                    if (dynamicrequest) {
                        dynamicrequest.abort();
                    }

                    var ajaxurl = $(this).attr('href');

                    $.ajax({
                        type: 'GET',
                        url: ajaxurl,
                        success: function(response) {
                            ajaxload.html(response).removeClass('loading');

                            console.log(ajaxitem.html())
                            ajaxitem.text('Close').closest('div.ajax').addClass('current');

                            new scrollToDiv(ajaxload, 0);
                            new emailsiteProtect();
                            new shareSetup('#ajaxload ');

                            if ($('#videoslideshow div.item').length > 1) {
                                new videoslideshowSetup('videoslideshow', true);
                            }

                            window.history.pushState(ajaxurl, null, ajaxurl);

                            dynamicrequest = null;
                        }
                    });
                }
            });

        }

        if ($('#ajaxportfolio').length > 0) {
            /*
            responsive = {
            	0	:{items:1},
                600	:{items:3},
                800	:{items:5}
            };
            new carouselSetup('ajax', 5, responsive);
            */

            var baseurl = window.location.href;

            var breakpoints = {
                4: 768,
                3: 550,
                2: 375,
                1: 0
            };

            var winwidthloaded = winwidth;

            ajaxload = $('#ajaxload');
            ajaxholder = $('#ajaxportfolio');
            var $items = $("#ajaxportfolio div.otherboxinner > a");
            $items.click(function(event) {
                event.preventDefault();

                var ajaxitem = $(this);

                if (ajaxitem.parent().hasClass('current')) {
                    ajaxitem.parent().removeClass('current');
                    ajaxload.removeClass('ajaxload portfolio resize').html('').removeAttr('style');

                    window.history.pushState(baseurl, null, baseurl);
                } else {

                    $('#ajaxportfolio div.otherboxinner').removeClass('current');

                    if (dynamicrequest) {
                        dynamicrequest.abort();
                    }

                    var $expandedIdx = $items.index(ajaxitem);
                    var $iteminjectbefore = null;
                    var $pos = 0;
                    var margins = ajaxholder.offset().left;

                    $items.each(function() {
                        console.log($(this).closest('div.otherbox').position().left)

                        if (parseInt($(this).closest('div.otherbox').position().left) == 0 && $pos > $expandedIdx && !$iteminjectbefore) {
                            console.log('here');
                            $iteminjectbefore = $items.eq($pos - 1);
                        };

                        $pos++;
                    });

                    if (!$iteminjectbefore) {
                        $iteminjectbefore = $items.last();
                    }

                    $iteminjectbefore.closest('div.otherbox').after(ajaxload);

                    ajaxload.addClass('ajaxload portfolio resize loading').html('').css({
                        'margin-left': '-' + margins + 'px',
                        'margin-right': '-' + margins + 'px'
                    });

                    var ajaxurl = $(this).attr('href');

                    $.ajax({
                        type: 'GET',
                        url: ajaxurl,
                        success: function(response) {
                            ajaxload.html(response).removeClass('loading');

                            ajaxitem.parent().addClass('current');

                            new scrollToDiv(ajaxload, 0);
                            new breakpointKey(breakpoints, winwidth);
                            new emailsiteProtect();
                            new shareSetup('#ajaxload ');

                            /*
                            if ($('#videoslideshow div.item').length > 1) {
                                new videoslideshowSetup('videoslideshow', true, true);
                            }

                            if ($('#videoonlyslideshow div.item').length > 0) {
                                new videoslideshowSetup('videoonlyslideshow', false, false);
                            }
                            */

                            new gallerySetup();

                            window.history.pushState(ajaxurl, null, ajaxurl);

                            winwidthkeyloaded = winwidthkey;
                            dynamicrequest = null;
                        }
                    });
                }
            });

            $(window).load(function() {
                //new setBoxHeights('div.otherbox a');
            });

            $(window).resize(function() {
                //new setBoxHeights('div.otherbox a');

                if (ajaxload) {
                    winwidth = $(window).width();

                    new breakpointKey(breakpoints, winwidth);

                    if (winwidthkey != winwidthkeyloaded) {
                        ajaxload.removeClass('ajaxload portfolio resize').html('');
                        $('#ajaxportfolio div.otherboxinner').removeClass('current');
                    }

                    if (ajaxload.hasClass('resize')) {
                        var margins = ajaxholder.offset().left;

                        ajaxload.css({
                            'margin-left': '-' + margins + 'px',
                            'margin-right': '-' + margins + 'px'
                        });
                    }
                }
            });

        }

        if ($('#otherboxcarousel').length > 0) {
            responsive = {
                0: {
                    items: 1
                },
                500: {
                    items: 2
                },
                800: {
                    items: 3
                }
            };
            new carouselSetup('otherbox', 3, responsive);
        }

        new menuSetup();

        $(".fancybox").fancybox({
            maxWidth: 1200,
            maxHeight: '90%',
            fitToView: true,
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            padding: 5,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });

        if ($('#mapinline').length > 0) {
            new mapSetup();
        }

        var searchbar = $("#searchbar");

        $('#searchlink').click(function(event) {
            if (!mobilemenu) {
                event.preventDefault();

                if (searchbar.hasClass('open')) {
                    searchbar.removeClass('open').hide();
                } else {
                    searchbar.addClass('open').stop().show().css('left', '-' + (searchbar.outerWidth()) + 'px').animate({
                        'left': 0
                    }, 500, "easeOutQuad");
                    $('li.search-bar input.text').focus();
                }
            }
        });

        var searchField = $('#SearchForm_SearchForm_Search');
        var default_value = searchField.val();
        searchField.focus(function() {
            $(this).addClass('active');
            if (searchField.val() == default_value) {
                searchField.val('');
            }
        });

        searchField.blur(function() {
            if (searchField.val() == '') {
                searchField.val(default_value);
            }
        });

        // Hijack hash links
        $('a[href*="#"]').click(function(event) {
            var id = $(this).attr('href').substring($(this).attr('href').indexOf("#"));

            var elem;

            if ($(id).length > 0) {
                elem = $(id);
            } else {
                id = id.substr(1);
                elem = $('[name=' + id + ']');
            }

            if (elem.length > 0) {
                event.preventDefault();

                new scrollToDiv(elem, (mobilemenu ? 0 : $('header').height()));
            }
        });

        // Parent readmore click
        $('div.homebox h2, div.homebox p').click(function() {
            var item = $(this);
            window.location.href = item.parent().find('ul.readmore li a').attr('href');
        });

        $('div.ajaxinner h2, div.ajaxinner p').click(function() {
            var item = $(this);
            item.parent().parent().find('ul.readmorepage li a').click();
        });

        $('div.ajaxinner img').click(function() {
            var item = $(this);
            item.parent().parent().parent().find('ul.readmorepage li a').click();
        });

        new emailsiteProtect();
        new shareSetup('');

        $('a.historyback').click(function(event) {
            event.preventDefault();

            new historyBack();
        });

        $('#print').click(function() {
            window.print();
        });
    });

    $(window).load(function() {
        $('body').addClass('loaded');

        if ($('#Form').hasClass('filtered')) {
            new scrollToDiv($('#FilterForm'), 0);
        }
    });

})(jQuery);

(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/all.js#xfbml=1";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));